/**
 * Object containing utility functions that may be useful on their own.
 * @type {object}
 */
 const utils = {
    /*
     * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
     * Author: Jim Palmer (based on chunking idea from Dave Koelle)
     * Contributors: Mike Grier (mgrier.com), Clint Priest, Kyle Adams, guillermo
     * See: http://js-naturalsort.googlecode.com/svn/trunk/naturalSort.js
     */
    naturalSort(a, b, html) {
        const re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?%?$|^0x[0-9a-f]+$|[0-9]+)/gi;
        const sre = /(^[ ]*|[ ]*$)/g;
        const dre = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[/-]\d{1,4}[/-]\d{1,4}|^\w+, \w+ \d+, \d{4})/;
        const hre = /^0x[0-9a-f]+$/i;
        const ore = /^0/;
        const htmre = /(<([^>]+)>)/ig;

        // Convert all to strings and trim()
        let x = a.toString().replace(sre, '') || '';
        let y = b.toString().replace(sre, '') || '';

        // Remove html from strings if desired
        if (!html) {
            x = x.replace(htmre, '');
            y = y.replace(htmre, '');
        }

        // Chunk/tokenize
        const xN = x.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');
        const yN = y.replace(re, '\0$1\0').replace(/\0$/, '').replace(/^\0/, '').split('\0');

        // Numeric, hex or date detection
        const xD = parseInt(x.match(hre), 10) || (xN.length !== 1 && x.match(dre) && Date.parse(x));
        const yD = parseInt(y.match(hre), 10) || (xD && y.match(dre) && Date.parse(y)) || null;

        // First try and sort Hex codes or Dates
        if (yD) {
            if (xD < yD) {
                return -1;
            } else if (xD > yD) {
                return 1;
            }
        }

        // Natural sorting through split numeric strings and default strings
        for (let cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc += 1) {
            // Find floats not starting with '0', string or 0 if not defined (Clint Priest)
            let oFxNcL = !(xN[cLoc] || '').match(ore) && parseFloat(xN[cLoc], 10) || xN[cLoc] || 0; // eslint-disable-line
            let oFyNcL = !(yN[cLoc] || '').match(ore) && parseFloat(yN[cLoc], 10) || yN[cLoc] || 0; // eslint-disable-line

            // Handle numeric vs string comparison - number < string - (Kyle Adams)
            if (Number.isNaN(oFxNcL) !== Number.isNaN(oFyNcL)) {
                return (Number.isNaN(oFxNcL)) ? 1 : -1;
            } else if (typeof oFxNcL !== typeof oFyNcL) {
                // Rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
                oFxNcL = String(oFxNcL);
                oFyNcL = String(oFyNcL);
            }

            if (oFxNcL < oFyNcL) {
                return -1;
            }

            if (oFxNcL > oFyNcL) {
                return 1;
            }
        }

        return 0;
    },

    /**
     * Take a raw string and capitalize the first letter.
     *
     * @param {string} rawString Starting string.
     *
     * @returns {string}
     */
    ucFirst(rawString) {
        return rawString.charAt(0).toUpperCase() + rawString.slice(1);
    },
};

export default utils;
